import React from "react";
import PropTypes from "prop-types";
import styles from "./legend.module.scss";

const Legend = ({min, max, steps, labels}) => {
  var stepBoxes = []
  for(var i = 0; i < steps; i++){
    stepBoxes.push(max/steps*(i+1))
  }

  return (
    <div style={{marginBottom:'10px'}}>
      <div className={styles.legendWrapper}></div>
      <div className={styles.legendLabelWrapper}>
        <span className={styles.legendLabelItem}>0</span>
        {
          stepBoxes.map((step, i) => {
            return (<span key={step+i} className={styles.legendLabelItem}>{step}</span>)
          })
        }
      </div>
      <div className={styles.legendLabelWrapper}>
        {
          labels.map((label, i) => {
            return (<span key={label+i} className={styles.legendLabelItem}>{label}</span>)
          })
        }
      </div>
    </div>
  );
};

Legend.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  steps: PropTypes.number,
};

export default Legend;



// WEBPACK FOOTER //
// ./src/components/legend/legend.js